// This component handles the App template used on every page.
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Header from './features/common/components/Header';
import Auth0Footer from '@a0/auth0-footer';
import * as contactActions from './features/sales/actions/contactActions';
import { loadLocalities as commonLoadLocalities } from '@a0/support-center-common/lib/localities';
import api from './api';


const App = ({ actions, auth, children }) => {

  useEffect(function loadLocalitiesOnAppStart() {
    commonLoadLocalities(async () => await api.localities.get());
  }, []);

  function onContactSales(event, metadata) {
    event.preventDefault();
    actions.contactSales('header', metadata);
  }

  const changeLang = () => {
    return null;
  };
  return (
    <div className="support-page">
      <Header
        auth={auth}
        contactSales={onContactSales}
      />
      <div>{children}</div>
      <div className="footer-container">
        <Auth0Footer
          baseUrl="https://auth0.com"
          theme="light"
          lang="en"
          onChangeLang={changeLang} />
      </div>
    </div>
  );
};

App.propTypes = {
  children: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...contactActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
